import React, { useEffect, useState } from "react";
import ContactPopup from "../../components/ContactPopup";
import DynamicHeaderSection from "../../components/Dynamic/DynamicHeaderSection";
import TheGapSection from "../../components/Dynamic/TheGapSection";
import CampusToCorporateSection from "../../components/Dynamic/CampusToCorporateSection";
import DynamicFrameworkSection from "../../components/Dynamic/DynamicFrameworkSection";
import DynamicUspSection from "../../components/Dynamic/DynamicUspSection";
import DynamicTestimonial from "../../components/Dynamic/DynamicTestimonial";
import DynamicFaqSection from "../../components/Dynamic/DynamicFaqSection";
import DynamicBg from "../../components/Dynamic/DynamicBg";
import "./dynamic.css";
import { BaseUrl } from "../../helper/BaseUrl";
import { useNavigate, useParams } from "react-router-dom";

export default function Dynamic({ initialData }) {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const { slug } = useParams();
  const [aiData, setAiData] = React.useState(initialData || {});
  const navigate = useNavigate();

  const aifetcher = async () => {
    try {
      const response = await fetch(  `${BaseUrl}/api/service-dynamic-page/detail/${slug}`, 
         {  method: "GET",},
      );

      const result = await response.json();
      if (!response.ok || !result?.data) {
        navigate("/404", { replace: true });
        return;
      }
      setAiData(result.data);
    } catch (error) {
      console.error("Fetch error:", error);
      navigate("/404", { replace: true });
    }
  };
  useEffect(() => {
    if (slug) {
      aifetcher();
    }
  }, [slug]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="dynamic-page">
      <DynamicHeaderSection  aiData={aiData}   onAction={() => setIsPopupOpen(true)} />
      <TheGapSection aiData={aiData} />
      <CampusToCorporateSection  aiData={aiData}  onAction={() => setIsPopupOpen(true)}  />
      <DynamicFrameworkSection aiData={aiData} />
      <DynamicUspSection  aiData={aiData} onAction={() => setIsPopupOpen(true)}  />
      <DynamicTestimonial aiData={aiData} />
      <DynamicBg aiData={aiData} onAction={() => setIsPopupOpen(true)} />
      <DynamicFaqSection />
      <ContactPopup isOpen={isPopupOpen}  onClose={() => setIsPopupOpen(false)}/>
    </div>
  );
}
